import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MATERIAL_IMPORTS } from '../../../material/material-imports';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { ProblemListComponent } from '../../problem/problem-list/problem-list.component';
import { ActivatedRoute, Params } from '@angular/router';
import { FormControl } from '@angular/forms';

import { ProblemModel } from '@generativ/much-smarter-models';
import { ExerciseService } from '../exercise.service';
import { Observable ,  Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ProblemService } from '../../../shared/problem.service';
import { ExerciseModel, ExerciseRequest } from '@generativ/much-smarter-models';

import { AlertService } from '../../../core/alert/alert.service';




@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, ...MATERIAL_IMPORTS, CapitalizePipe, SpinnerComponent, ProblemListComponent],
  selector: 'app-exercise-management',
  templateUrl: './exercise-management.component.html',
  styleUrls: ['./exercise-management.component.scss']
})
export class ExerciseManagementComponent implements OnInit {

  readonly exercise = signal<ExerciseModel | null>(null);
  exerciseId: number;
  currentProblem: string;
  loading = false;


  constructor(private route: ActivatedRoute,
              private exerciseService: ExerciseService,
              private problemService: ProblemService,
              private alertService: AlertService) {
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.exerciseId = +params['exerciseId'];
      this.exerciseService.getExercise(this.exerciseId).subscribe(
        exerciseModel => {
          this.exercise.set(exerciseModel);
        },
        err => this.alertService.error(err)
      );
    });
  }
}
